// extracted by mini-css-extract-plugin
export var bodyOpen = "ModalDialog-module--bodyOpen--2b4ca";
export var confirm = "ModalDialog-module--confirm--63687";
export var modal = "ModalDialog-module--modal--b455d";
export var overlay = "ModalDialog-module--overlay--98d31";